import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home, Phone, Instagram, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import '../styles/thankyou.css';

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
    
    // Envoyer l'événement de conversion à Google Ads
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17305134091/CONVERSION_LABEL', // Remplacez CONVERSION_LABEL par votre vrai label de conversion
        'value': 1.0,
        'currency': 'EUR'
      });
    }
  }, []);

  return (
    <div className="thankyou-container">
      {/* Header */}
      <header className="thankyou-header">
        <div className="thankyou-logo-section">
          <img 
            src="https://customer-assets.emergentagent.com/job_49df62c5-2f2b-4015-9d48-0abd42138eec/artifacts/jxvxk1uq_file_00000000b8f0720a897da348f1691752.png" 
            alt="Pizza Mamma Logo" 
            className="thankyou-logo"
          />
          <div className="thankyou-brand-name">
            <span className="brand-pizza">PIZZA</span>
            <span className="brand-mamma">MAMMA</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="thankyou-main">
        <div className="thankyou-content">
          <div className="success-icon-wrapper">
            <CheckCircle className="success-icon" size={80} />
          </div>
          
          <h1 className="thankyou-title">
            Merci pour votre demande !
          </h1>
          
          <p className="thankyou-message">
            Votre demande de devis a été envoyée avec succès. 
            Nous avons bien reçu vos informations et nous vous recontacterons 
            dans les plus brefs délais pour discuter de votre événement.
          </p>

          <div className="thankyou-info-box">
            <h3 className="info-box-title">📧 Prochaines Étapes</h3>
            <ul className="info-box-list">
              <li>✅ Nous étudions votre demande</li>
              <li>📞 Nous vous appellerons sous 24-48h</li>
              <li>🍕 Nous préparerons un devis personnalisé pour votre événement</li>
            </ul>
          </div>

          <div className="thankyou-contact-section">
            <h3 className="contact-section-title">Une question urgente ?</h3>
            <div className="contact-methods">
              <a href="tel:0613658698" className="contact-method">
                <Phone size={20} />
                <span>06 13 65 86 98</span>
              </a>
              <a href="https://wa.me/33613658698" target="_blank" rel="noopener noreferrer" className="contact-method whatsapp">
                <Phone size={20} />
                <span>WhatsApp</span>
              </a>
              <a href="mailto:maarekpaul@gmail.com" className="contact-method">
                <Mail size={20} />
                <span>Email</span>
              </a>
              <a href="https://instagram.com/pizzamamma94" target="_blank" rel="noopener noreferrer" className="contact-method">
                <Instagram size={20} />
                <span>@pizzamamma94</span>
              </a>
            </div>
          </div>

          <div className="thankyou-actions">
            <Button onClick={() => navigate('/')} className="btn-home">
              <Home className="mr-2" size={20} />
              Retour à l'accueil
            </Button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="thankyou-footer">
        <p>&copy; 2024 Pizza Mamma - L'authenticité italienne à Créteil</p>
      </footer>
    </div>
  );
};

export default ThankYou;
